// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"36bf271e","142":"b07d8bd8"}[chunkId] + ".chunk.css";
};